export function normalizeSpecialsDisplayName(
  customName: string | null | undefined
): string {
  return !customName || ['Specials', 'Deals'].includes(customName)
    ? 'Deals'
    : customName;
}
